import SoundController from '../CallManager/SoundController';
import Ringtone from '../../resources/ringtone.mp3';

const sound = new SoundController(Ringtone);
export default sound;